/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 車種情報のリスト
 * @export
 * @interface GetCarTypes200ResponseInner
 */
export interface GetCarTypes200ResponseInner {
    /**
     * 車種コード
     * @type {string}
     * @memberof GetCarTypes200ResponseInner
     */
    carTypeCode: string;
    /**
     * 車種名
     * @type {string}
     * @memberof GetCarTypes200ResponseInner
     */
    name: string;
    /**
     * 最大乗員数
     * @type {number}
     * @memberof GetCarTypes200ResponseInner
     */
    maxPassengers: number;
    /**
     * 最大荷物数
     * @type {number}
     * @memberof GetCarTypes200ResponseInner
     */
    maxBuggage: number;
    /**
     * 種別
     * @type {number}
     * @memberof GetCarTypes200ResponseInner
     */
    kind?: number;
    /**
     * タイムスタンプ
     * @type {string}
     * @memberof GetCarTypes200ResponseInner
     */
    updateTimestamp: string;
}

/**
 * Check if a given object implements the GetCarTypes200ResponseInner interface.
 */
export function instanceOfGetCarTypes200ResponseInner(value: object): value is GetCarTypes200ResponseInner {
    if (!('carTypeCode' in value) || value['carTypeCode'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('maxPassengers' in value) || value['maxPassengers'] === undefined) return false;
    if (!('maxBuggage' in value) || value['maxBuggage'] === undefined) return false;
    if (!('updateTimestamp' in value) || value['updateTimestamp'] === undefined) return false;
    return true;
}

export function GetCarTypes200ResponseInnerFromJSON(json: any): GetCarTypes200ResponseInner {
    return GetCarTypes200ResponseInnerFromJSONTyped(json, false);
}

export function GetCarTypes200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCarTypes200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'carTypeCode': json['car_type_code'],
        'name': json['name'],
        'maxPassengers': json['max_passengers'],
        'maxBuggage': json['max_buggage'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'updateTimestamp': json['update_timestamp'],
    };
}

export function GetCarTypes200ResponseInnerToJSON(json: any): GetCarTypes200ResponseInner {
    return GetCarTypes200ResponseInnerToJSONTyped(json, false);
}

export function GetCarTypes200ResponseInnerToJSONTyped(value?: GetCarTypes200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'car_type_code': value['carTypeCode'],
        'name': value['name'],
        'max_passengers': value['maxPassengers'],
        'max_buggage': value['maxBuggage'],
        'kind': value['kind'],
        'update_timestamp': value['updateTimestamp'],
    };
}

